module.exports = __webpack_public_path__ + "static/media/norwegian-bank.cdb5a02e.svg";